module.exports = __webpack_public_path__ + "img/hrv.4680d632.svg";